import { Microphone, GearSix, ArrowClockwise, X } from "@phosphor-icons/react";
import { settingsInstructions } from "@/lib/devicePermissions";

// Alerta amigable cuando falta un permiso obligatorio (p.ej. micrófono) para hablar con Jared.
export default function JaredPermissionAlert({ permission = "microphone", onRetry, onClose }) {
  const label = permission === "camera" ? "la cámara" : "el micrófono";
  const steps = settingsInstructions(label);
  return (
    <div className="fixed inset-0 z-[70] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
         data-testid="jared-permission-alert">
      <div className="w-full max-w-sm rounded-2xl bg-[#111318] border border-zinc-800 text-white overflow-hidden shadow-2xl">
        <div className="px-6 pt-6 pb-3 text-center">
          <div className="mx-auto w-14 h-14 rounded-full flex items-center justify-center mb-3"
               style={{ background: "rgba(227,30,36,0.15)" }}>
            <Microphone size={28} weight="duotone" style={{ color: "var(--brand,#E31E24)" }} />
          </div>
          <h3 className="text-lg font-bold">Necesito acceso {`a ${label}`}</h3>
          <p className="text-sm text-slate-400 mt-1">
            Para conversar por voz, activa {label} en tu dispositivo.
          </p>
        </div>
        <div className="px-6 pb-2">
          <div className="rounded-xl bg-zinc-900/60 border border-zinc-800 p-3">
            <div className="flex items-center gap-2 text-xs font-semibold text-slate-300 mb-2">
              <GearSix size={16} weight="duotone" /> Cómo activarlo
            </div>
            <ol className="list-decimal ml-4 space-y-1 text-xs text-slate-400">
              {steps.map((s, i) => <li key={i}>{s}</li>)}
            </ol>
          </div>
        </div>
        <div className="px-6 py-4 flex flex-col gap-2">
          <button onClick={onRetry} data-testid="permission-alert-retry"
                  className="w-full py-3 rounded-xl font-semibold text-white flex items-center justify-center gap-2 transition-opacity hover:opacity-90"
                  style={{ background: "var(--brand,#E31E24)" }}>
            <ArrowClockwise size={18} weight="bold" /> Reintentar permiso
          </button>
          <button onClick={onClose} data-testid="permission-alert-close"
                  className="w-full py-2 rounded-xl text-sm text-slate-400 hover:text-white transition-colors flex items-center justify-center gap-1">
            <X size={14} /> Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
